require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-the-mills-at-yarrabend.json") })
        }
      }, "path---news-the-mills-at-yarrabend");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-the-mills-at-yarrabend!./.cache/json/news-the-mills-at-yarrabend.json
// module id = 856
// module chunks = 231608221292675